﻿import {$$} from "@/Utils"

function showTooltip(e: HTMLElement) {
    e.classList.add("open");
    const tooltipWrapper = e.closest(".tooltip__wrapper");
    const tooltip = tooltipWrapper.querySelector(".tooltip") as HTMLElement;
    let tooltipPosition = e.getAttribute("data-tooltip");
    const tooltipContainClass = e.getAttribute("data-tooltip-contain");
    const tooltipContain = !!tooltipContainClass;

    tooltip.classList.add("tooltip--visible");
    let top: number = null;
    let left = e.offsetLeft;
    let arrowTop: number = null;
    let marginTop = "";

    const buttonHeight = e.clientHeight;
    const buttonBox = e.getBoundingClientRect()
    const icon = e.querySelector(".icon i") ?? e;
    const iconBox = icon.getBoundingClientRect()
    const iconOffset = iconBox.x - buttonBox.x + iconBox.width * 0.5

    const tipMargin = 15;

    const halfContentWidth = tooltip.clientWidth * 0.5;
    if (tooltipContain) {
        const contain = e.closest(`.${tooltipContainClass}`);
        const containBox = contain.getBoundingClientRect();
        tooltip.style.width = containBox.width + "px";

        left += containBox.x - buttonBox.x;
        let tooltipWidth = tooltip.getBoundingClientRect().width;

        // Checking if the right side of the button is further left than the right side of the tooltip
        if (buttonBox.x + buttonBox.width > buttonBox.x + tooltipWidth + left) {
            left = (containBox.x + containBox.width) - (buttonBox.x + tooltip.clientWidth);
            // Checking if the left side of the tooltip is now further right than the left side of the button
            if (containBox.x + containBox.width - tooltipWidth > buttonBox.x) {
                left = 0;
            }
        }
    } else {
        left -= halfContentWidth
    }

    const contentHeight = tooltip.clientHeight;

    if (tooltipPosition === "top") {
        if (buttonBox.y < contentHeight + tipMargin) {
            tooltipPosition = "bottom";
            tooltip.classList.remove("tooltip--top");
            tooltip.classList.add("tooltip--bottom");
        } else {
            tooltipPosition = "top";
            tooltip.classList.add("tooltip--top");
            tooltip.classList.remove("tooltip--bottom");
        }
    }
    switch (tooltipPosition) {
        case "top":
            top = -contentHeight - tipMargin;
            break;
        case "bottom":
            top = buttonHeight + tipMargin;
            break;
    }
    if (!tooltipContain && buttonBox.x - halfContentWidth < 0) {
        left += halfContentWidth - buttonBox.x
    }
    const documentRight = document.body.getBoundingClientRect().right
    if (!tooltipContain && buttonBox.x + halfContentWidth > documentRight) {
        left -= buttonBox.x + halfContentWidth - documentRight
    }
    if (!isNaN(left)) tooltip.style.left = left + "px";
    if (!isNaN(top)) tooltip.style.top = top + "px";
    const tooltipBoundingBox = tooltip.getBoundingClientRect()
    if (tooltipBoundingBox.right + tipMargin > documentRight) {
        tooltip.style.right = (buttonBox.right - document.body.getBoundingClientRect().right) + 'px' // window.innerWidth - tipMargin + "px"
    }
    tooltip.style.marginTop = marginTop;
    const arrow = tooltip.querySelector(".tooltip__arrow-triangle") as HTMLElement;
    arrow.style.left = `${-left + iconOffset + e.offsetLeft}px`;
    if (!isNaN(arrowTop)) arrow.style.top = `${arrowTop}px`;
}

function hideTooltip(e: HTMLElement): boolean {
    const wasOpened = e.classList.contains("open");
    e.classList.remove("open");
    e.parentElement.querySelector(".tooltip--visible")?.classList.remove("tooltip--visible");
    return wasOpened;
}

export function initTooltips() {
    $$("[data-tooltip]").forEach((e: Element) => {
        e.addDataBoundEventListener("click", (ev: Event) => {
            ev.preventDefault()
            const target = ev.currentTarget as HTMLElement;
            if (target.classList.contains("open")) {
                hideTooltip(target)
            } else {
                showTooltip(target)
            }
        }, "click")
    })
}

export function closeOtherTooltips(targetTooltip: Element): boolean {
    let wasAnyHidden = false
    $$("[data-tooltip]").forEach((tooltip: HTMLElement) => {
        if (tooltip !== targetTooltip) {
            wasAnyHidden ||= hideTooltip(tooltip)
        }
    })
    return wasAnyHidden
}